/**
 * Data layer for `igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline`. Thin typed fetch wrappers over /api/v1/igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineResponse {
	count: number;
	items: IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRow[];
}

export interface CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineResponse>(res);
}

export async function create(body: CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineBody): Promise<IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys = {
	all: ["igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline"] as const,
	list: () => [...igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys.all] as const,
	detail: (id: string) => [...igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys.all, id] as const,
};
